import { render, staticRenderFns } from "./PrivateRelayWarningDialog.vue?vue&type=template&id=4cc9d3c8&scoped=true"
import script from "./PrivateRelayWarningDialog.vue?vue&type=script&lang=js"
export * from "./PrivateRelayWarningDialog.vue?vue&type=script&lang=js"
import style0 from "./PrivateRelayWarningDialog.vue?vue&type=style&index=0&id=4cc9d3c8&prod&scoped=true&lang=css"
import style1 from "./PrivateRelayWarningDialog.vue?vue&type=style&index=1&id=4cc9d3c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc9d3c8",
  null
  
)

export default component.exports